import React from 'react'
import { useAppSelector } from '../redux/hooks'
import User from '../models/User'
import { selectUserData } from '../redux/actions/login/loginSlice'
import AuthLayout from '../pages/_layout/AuthLayout'
import AffilateMain from './pages/_layout/AffilateMain'
import Login from './pages/login/login'
import Dashboard from './pages/dashboard/dashboard'
import AffilateUser from './pages/Affilate/AffilateUser'

import AffilateComm from './pages/Affilate/AffilateComm'
import AffilateTransection from './pages/Affilate/AffilateTransection'
const AffilateRoutes = () => {
  const userState = useAppSelector<{ user: User }>(selectUserData)

  return [
    {
      path: '/affilate',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: <Login /> },
        {
          path: '',
          element: <AffilateMain />,
          children: [
            { index: true, element: <Dashboard /> },
            { path: 'users', element: <AffilateUser /> },
            { path: 'account-statement', element: <AffilateTransection /> },
            { path: 'commission', element: <AffilateComm /> },
            // Add other affiliate routes here
          ],
        },
      ],
    },
  ]
}

export default AffilateRoutes